import { RecontactTemplateState } from './types';
import { recontactTemplateUrl } from './urls';

import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';

export async function getRecontactTemplate(
  websiteId: string
): Promise<RecontactTemplateState> {
  const { result } = await HsmBackendHttpClient.instance.get<
    HsmBackendResponse<RecontactTemplateState>
  >(recontactTemplateUrl(websiteId));

  return result;
}

export async function submitRecontactTemplate(
  websiteId: string,
  text: string
): Promise<RecontactTemplateState> {
  const { result } = await HsmBackendHttpClient.instance.post<
    HsmBackendResponse<RecontactTemplateState>
  >(recontactTemplateUrl(websiteId), { text });

  return result;
}

export async function dismissRecontactTemplate(
  websiteId: string
): Promise<void> {
  await HsmBackendHttpClient.instance.post(
    `${recontactTemplateUrl(websiteId)}/dismiss`
  );
}
